import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';

interface PortalProps {
  children: React.ReactNode;
  portalId?: string;
}

export function Portal({ children, portalId = 'portal-root' }: PortalProps) {
  const [mounted, setMounted] = useState(false);
  const portalRoot = document.getElementById(portalId);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted || !portalRoot) return null;

  return createPortal(children, portalRoot);
}
